import { Flex } from '@indoqa/style-system';
import * as React from 'react';
import { withUIETheme } from '../uietheme/withUIETheme';
import { FontMixPanel } from './FontMixPanel';
import HeadlineFontStylePanel from './HeadlineFontPanel';
import { TextFontPanel } from './TextFontPanel';
const renderTextFont = (font) => {
    return React.createElement(TextFontPanel, { key: font.name, name: font.name, fontStyles: font.fontStyle });
};
const renderHeadlineFont = (font, fontSizes) => {
    return React.createElement(HeadlineFontStylePanel, { key: font.name, name: font.name, fontStyles: font.fontStyle, fontSizes: fontSizes });
};
const renderFontMixes = (fontMix, fontSizes, textFontSize) => {
    return React.createElement(FontMixPanel, { key: fontMix.name, fontMix: fontMix, fontSizes: fontSizes, textFontSize: textFontSize });
};
const TypographyPanelInternal = ({ textFonts, headlineFonts, fontMixes, fontSizes, textFontSize }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Flex, null, headlineFonts.map((font) => renderHeadlineFont(font, fontSizes))),
        React.createElement(Flex, null, textFonts.map((font) => renderTextFont(font))),
        React.createElement(Flex, null, fontMixes.map((fontMix) => renderFontMixes(fontMix, fontSizes, textFontSize)))));
};
export const TypographyPanel = withUIETheme(TypographyPanelInternal);
//# sourceMappingURL=TypographyPanel.js.map